import React from "react";

interface DropzoneInputPropsWithRef {
    ref: React.MutableRefObject<HTMLInputElement | null>;
}

/**
 * Workaround for a bug in react-dropzone where it doesn't set the ref
 * correctly in some cases, and its types are incorrect.
 * Use this as the `ref` callback on dropzone input elements.
 */
export function setDropzoneRef(
    inputProps: unknown,
    el: HTMLInputElement | null,
): void {
    (inputProps as DropzoneInputPropsWithRef).ref.current = el;
}
